import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class TrackerSupportCard extends Vue {
  @Getter getCurrentOrder: any
  @Getter getUniversity: any

  @State user: any
  @State supportTracker: any
  @State orders: any
  @State university: any

  // _openIntercom () {
  //   (window as any).Intercom('show')
  // }

  _domiciliaryName () {
    let deliveryName = ''
    if (!this.getCurrentOrder.delivery || !this.getCurrentOrder.delivery.delivery_man) {
      deliveryName = 'No asignado'
    } else {
      deliveryName = `${this.getCurrentOrder.delivery.delivery_man.first_name} ${this.getCurrentOrder.delivery.delivery_man.last_name}`
    }
    return deliveryName
  }
}
